import Delete from '@mui/icons-material/Delete'
import { Button, Fab, FormControlLabel, IconButton, Radio } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { StyledClinicBrandPhoneNumberInput } from 'src/mentor/components/MentorProfilePage/MentorProfilePageStyles'
import { getValueFromDotOperatorString } from 'src/shared/utils/objectPath'
import { isMobileEmpty } from 'src/shared/utils/phoneUtils'
import { StyledClinicBrandStaffInputComponent } from '../../ClinicOnboardingStyles'
import { isValidEmail } from './utils'
import { hasDuplicateStrings, isTheDuplicateStringInList } from 'src/consumer/helpers/utilFunctions'

export default function ClinicBrandOnboardingProspectInput({
  idx,
  prospectTypeValue,
  item,
  parentObject,
  handleChangeProspects,
  handleRemoveProspect,
}) {
  // const [inputType, setInputType] = useState()
  const phoneInputRef = useRef()

  const allEmailsInProspect = (
    getValueFromDotOperatorString(parentObject, prospectTypeValue?.id) || []
  )?.map((prospect) => {
    return prospect?.email
  })
  const allMobilesInProspect = (
    getValueFromDotOperatorString(parentObject, prospectTypeValue?.id) || []
  )?.map((prospect) => {
    return prospect?.mobile
  })

  const phoneIsValid =
    item?.mobile &&
    isValidPhoneNumber(`${item?.mobile}`) &&
    !isTheDuplicateStringInList({
      strings: allMobilesInProspect?.filter((mobile) => !!mobile),
      stringToCheck: item?.mobile,
    })
  // const emailIsValid = !(!item?.email
  //   ? false
  //   : !isValidEmail(item?.email) ||
  //     checkForDuplicateEmailIds(
  //       getValueFromDotOperatorString(parentObject, prospectTypeValue?.id) || [],
  //     ))
  const emailIsValid = !!item?.email
    ? isValidEmail(item?.email) &&
      !isTheDuplicateStringInList({
        strings: allEmailsInProspect?.filter((email) => !!email),
        stringToCheck: item?.email,
      })
    : false

  const isEitherEmailOrMobileValid = phoneIsValid || emailIsValid

  function addIndianCodeToPhone() {
    if (isMobileEmpty(item?.mobile)) {
      handleChangeProspects(
        {
          target: {
            value: '+91',
          },
        },
        idx,
        prospectTypeValue.id,
        'mobile',
      )
    }
  }

  // useEffect(() => {
  //   if (!!item?.email) {
  //     setInputType('email')
  //   } else {
  //     setInputType('mobile')
  //   }
  // }, [item])

  return (
    <div className="d-flex">
      <div
        className="d-flex flex-column gap-2 p-3 w-100"
        style={{ background: '#0000000f', borderRadius: '7px' }}
      >
        <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
          <CustomInput
            key={idx}
            id={prospectTypeValue.id}
            value={item?.title}
            label="Name"
            onChange={(eve) => handleChangeProspects(eve, idx, prospectTypeValue.id, 'title')}
            inputAndMessageContainer={StyledClinicBrandStaffInputComponent}
          />
        </div>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
          <CustomInput
            key={idx}
            id={prospectTypeValue.id}
            value={item?.email}
            label="Email"
            onChange={(eve) => handleChangeProspects(eve, idx, prospectTypeValue.id, 'email')}
            inputAndMessageContainer={StyledClinicBrandStaffInputComponent}
            invalid={isEitherEmailOrMobileValid && !item?.email ? false : !emailIsValid}
            invalidMessage={
              !item?.email
                ? 'Email cannot be blank.'
                : !isValidEmail(item?.email)
                ? "Ensure your email has '@', a name like 'gmail', and ends with '.com', '.net', etc."
                : 'Looks like this email is already the list. Please use a different one.'
            }
          />
        </div>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
          <CustomInput
            inputAndMessageContainer={StyledClinicBrandStaffInputComponent}
            component={StyledClinicBrandPhoneNumberInput}
            value={item?.mobile}
            inputRef={phoneInputRef}
            pureInputProps={{
              onFocus: addIndianCodeToPhone,
            }}
            label="Mobile"
            placeholder="+91"
            showDropDown={false}
            onChange={(data) => {
              const value = data ? `+${data}` : null
              handleChangeProspects(
                {
                  target: {
                    value: value,
                  },
                },
                idx,
                prospectTypeValue.id,
                'mobile',
              )
            }}
            invalid={isEitherEmailOrMobileValid && !item?.mobile ? false : !phoneIsValid}
            invalidMessage={
              !item?.mobile
                ? 'Mobile cannot be blank.'
                : !isValidPhoneNumber(`${item?.mobile}`)
                ? 'Ensure your phone number has a country code and is 10 digits long.'
                : 'Looks like this phone is already the list. Please use a different one.'
            }
          />
        </div>
        {/* {inputType === 'email' ? (
      ) : (

      )} */}
      </div>
      <div
        className="d-flex flex-column justify-content-center m-0"
        onClick={() => handleRemoveProspect(prospectTypeValue, idx)}
        style={{
          marginTop: '10px',
          borderRadius: '0px !important',
          padding: '16px',
          cursor: 'pointer',
        }}
      >
        <Fab size="small" elevation={0} color="error" sx={{ zIndex: '1' }}>
          <Delete />
        </Fab>
      </div>
    </div>
  )
}

{
  /* <div className="d-flex align-items-center gap-3">
        <FormControlLabel
          labelPlacement="start"
          control={
            <Radio
              checked={inputType === 'email'}
              onChange={() => {
                setInputType('email')
              }}
            />
          }
          label="Email: "
        />
        <FormControlLabel
          labelPlacement="start"
          control={
            <Radio
              checked={inputType === 'mobile'}
              onChange={() => {
                setInputType('mobile')
              }}
            />
          }
          label="Mobile: "
        />
      </div> */
}
